import axios from "axios";
import { Navigate } from "react-router-dom";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export async function seventlist() {
  try {
    return await axios
      .get(`${baseUrl}/Swimmingevents/list-swimmingevents`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function swimplayertourregister(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-meet-registration`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Swimming Sports Event list
export async function getswimeventlistbydob(data) {
  try {
    return await axios
      .post(`${baseUrl}/get-swimming-events-based-on-details`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Swimming Individual Register
export async function swimmingregister(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-ind-register`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Swiming Individual Registeration
export async function swimplayertourpayment(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-individual-meet-pay-success`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Payment
export async function swimpaymentsuccess(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-update-athletics-paymentsuccess`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function swimplayerpaymentpending(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-inter-user-pay`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function seventdetail(id) {
  try {
    return await axios
      .get(`${baseUrl}/Swimmingevents/view/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function seventcreate(data) {
  try {
    return await axios
      .post(`${baseUrl}/Swimmingevents/create`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function seventupdate(data) {
  try {
    return await axios
      .get(`${baseUrl}/Swimmingevents/update`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function seventdelete(data) {
  try {
    return await axios
      .get(`${baseUrl}/Swimmingevents/delete`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function seventvalidate(data, data1) {
  try {
    return await axios
      .get(`${baseUrl}/Swimmingevents/validate/${data}/${data1}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Swimming Age Categories to tournament
export async function swimmingaddagecategory(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-swimming-agecate-events`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age category list in tournament wise
export async function addswimmingagecategorylist(tid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-meetagecategories-list/${tid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Athlete age category view in edit
export async function swimagecatedit(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-tour-agecategory-view/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age category update
export async function swimupdateagecat(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-update-agecategory-details`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Athlete age category view to list of events
export async function swimeventview(id, eid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-meetagecategoriesevents-list/${id}/${eid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add age category event
export async function swimaddeventagecat(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-add-new-event`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Delete age category event
export async function swimdeleteventagecat(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-remove-event`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Swimming Offline Tournament Entry List
export async function swimofflineentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/offline-swimming-entries-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Swimming Offline Tournament Entry
export async function swimofflineentryupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-swimming-offline-entries`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//swimming inter tournament entry list
export async function swimintertourentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-inter-school-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//swimming intra tournament entry list
export async function swimintratourentrylist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-intra-school-entries/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//athletics tournament refund list
export async function swimtourrefundlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-entries-refunded-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Bib number generate and regenerate for tournament players
export async function swimtournamentgeneratebib(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-set-bibno`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Missed Bib number generate for tournament players
export async function swimtournamentmissedgeneratebib(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-set-missed-bibno`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Bib number generate or regenerate for tournament players
export async function swimbibnogenerateornot(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-bibnolist/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Edit the Bib number
export async function swimeditbib(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-edit-bibno`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Edit the Relay Bib number
export async function relayswimeditbib(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-edit-relay-bibno`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//BIB Number Log List
export async function swimbibloglist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-bib-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//BIB Number Upload
export async function swimbibupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-import-bib-no`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Orderof events Upload
export async function swimordereventupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-import-event-order`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events List
export async function swimtourordereventslist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-events-list/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of events for player
export async function swimplayerorderofevents(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-player-order-of-events-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events View
export async function swimtourordereventsdelete(id, uid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-delete-events-order/${id}/${uid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events View
export async function swimtourordereventsview(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-view-events-order/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events Add
export async function swimtouraddorderevents(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-add-events-order`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events Update
export async function swimtourupdateorderevents(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-update-events-order`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events Log List
export async function swimordereventloglist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-order-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Result Delete
export async function swimdeleteresult(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-results-delete/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Result List
export async function adminswimresultlist(id) {
  try {
    return await axios
      .get(`${baseUrl}/all-swimming-results/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Result Log List
export async function swimreultloglist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-results-excel-log/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Result Upload
export async function adminswimresultupload(data) {
  try {
    return await axios
      .post(`${baseUrl}/import-swimming-results`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Group School List
export async function swimgroupchamlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-group-champions-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Overall and Individual Champion List
export async function swimchampionslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-overall-individual-champions-list`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add/Edit the players in Tournament school list
export async function adminswimedittour(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-edit-entries-track`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Group wise swimming Inter Tournament school list
export async function groupswimtourschoollist(id, grp) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-school-list-of-tournaments/${id}/${grp}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Swimming Inter Tournament school list
export async function swimtourschoollist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-school-list-of-tournaments/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Payment or not for tournament
export async function swimcheckpaymentpaidornot(tid, sid, uid) {
  try {
    return await axios
      .get(
        `${baseUrl}/check-swimming-paid-or-not?current_meet_id=${tid}&school_id=${sid}&user_id=${uid}`
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//External Payment or not for tournament
export async function swimcheckextpaymentpaidornot(tid, sid) {
  try {
    return await axios
      .get(
        `${baseUrl}/swimming-external-payment-receipt-info?tournament_meet_id=${tid}&school_id=${sid}`
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Search Athlete list in age category and school wise
export async function swimaddsearchathletelist(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-search`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Athlete list in age category and event wise
export async function swimaddathletelist(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-added-swimlist-eventwise`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Age category list in tournament wise
export async function swimaddathletedelete(tid, uid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-delete-swimmer/${tid}/${uid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Add Athlete  in age category and event wise
export async function swimaddathleteplayers(data) {
  try {
    return await axios
      .post(`${baseUrl}/add-swimming-swimmers`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Update Email and Mobile
export async function swimupdateathletemobemail(data) {
  try {
    return await axios
      .post(`${baseUrl}/update-mobile-email`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//player list in tournament wise
export async function swimaddathleteplayerlist(tid,sid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-added-swim?tournament_meet_id=${tid}&school_id=${sid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

 //Summary
export async function swimtoursummary(id,sid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-get-summary-page-info?tournament_id=${id}&school_id=${sid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


 //External Payment Account Info
 export async function swimtourextaccinfo(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-tournament-external-account-info/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Withraw From Free Tournament Events
export async function swimschoolheadfreetouredit(data) {
  try {
   
    return await axios
      .post(`${baseUrl}/swimming-withdraw-from-free-entry-tournament`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//confirmation pdf
 export async function swimconfplayerlist(tid,sid) {
  try {
    return await axios
      .get(`${baseUrl}/generate-swimming-confirmation-pdf/${tid}/${sid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events--> Add Heat
export async function swimtouraddheattoevents(data) {
  try {
    
    return await axios
      .post(`${baseUrl}/add-swimming-to-heats`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Remove athlete from Heat Start List
export async function swimtourremoveheatevent(data) {
  try {
    return await axios
      .post(`${baseUrl}/remove-swimming-from-heats`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//player list in event wise for tournament
export async function swimaddeventsplayerlist(tid,sid) {
    try {
      return await axios
        .get(`${baseUrl}/swimming-added-swimmerlist?tournament_meet_id=${tid}&school_id=${sid}`)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          catcherror(error);
        });
    } catch (error) {
      catcherror(error);
    }
  }

  //Order of Events Except Heat Start List
export async function swimtoureventstartexceptheatlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/get-start-list-of-swimming-except-heat`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events Start List -- time/distance list
export async function swimstartresultlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-get-results-data`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events with Heat Start List
export async function swimtoureventheatlist(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-list-with-heat-name`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Order of Events Start List --result update
export async function swimstartresultupdate(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-add-results-to-start-list`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Athletics Result List
export async function playerswimresult(tid, id) {
  try {
    return await axios
      .get(`${baseUrl}/all-swimming-results-player/${tid}/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Free Tournament
export async function swimtourentryfreepayment(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-submit-from-free-entry-tournament`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Offline Submit and Payment
export async function swimtourentryofflinepayment(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-submit-entry-from-admin`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Submit and Payment
 export async function swimtourpayment(data) {
  try {
    return await axios
      .post(`${baseUrl}/get-swimming-razorpay-orderid`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//Receipt Submit
export async function swimtourextreceipt(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-upload-external-payment-receipt`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//SWimming Player Overall Performance
export async function swimmysclperformance(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-overall-individual-champions-list-with-school`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
//District Group List
export async function swimdistgrouplist(id) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-groups-list?tournament_meet_id=${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//update offline payment for interschool in Tournament school list
export async function swiminterschoolupdateofflinepayment(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-update-offline-payment`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


//Change Refund Payment Status
export async function swimchangerefundpaymentstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-entrysent-refunded-log`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Send Payment Link to Player
export async function swimsendpaymentlink(tid, id) {
  try {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("Token"),
      "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/superadmin/swimming-send-meet-paymentlink/${tid}/${id}`, {
        headers: header,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//other than athletics check the payment status for intraschool in school discount list
export async function swimothertourpaymentstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/check-swimming-other-intra-pay-status`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//athletics check the payment status for intraschool in Tournament school discount  list
export async function swimintratourpaymentstatus(data) {
  try {
    return await axios
      .post(`${baseUrl}/check-swimming-intra-pay-status`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function swimplayerathletetourregister(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-ind-register-in-dashboard`, data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//group wise athletics inter tournament entry list
export async function swimgroupathleticsintertourentrylist(id,gid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-inter-school-entries-by-group/${id}/${gid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//group wise athletics intra tournament entry list
export async function swimgroupathleticsintratourentrylist(id,gid) {
  try {
    return await axios
      .get(`${baseUrl}/swimming-intra-school-entries-by-group/${id}/${gid}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

//Overall Champion List
export async function swimagecategorychampionslist(data) {
  try {
    return await axios
      .post(`${baseUrl}/swimming-individual-champions-list-by-age-cat`,data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
function catcherror(error) {
  console.log(error.response);
  if (error.response.status === 401) {
    localStorage.clear();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //       window.location.reload();
      //   }
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
